import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { ProductData } from '../models';

@Injectable({ providedIn: 'root' })
export class PubService extends BaseService<ProductData> {
    constructor(http: HttpClient) {
        super(http, '/pub');
    }
}
